__turbopack_context__.v({
  "balanceHistory": "account-transactions-module-sass-module__OEyp5W__balanceHistory",
  "content": "account-transactions-module-sass-module__OEyp5W__content",
  "currencyType": "account-transactions-module-sass-module__OEyp5W__currencyType",
  "header": "account-transactions-module-sass-module__OEyp5W__header",
  "tabletHeader": "account-transactions-module-sass-module__OEyp5W__tabletHeader",
});
